import { render, staticRenderFns } from "./ct-project.vue?vue&type=template&id=2293bb52&scoped=true"
import script from "./ct-project.vue?vue&type=script&lang=js"
export * from "./ct-project.vue?vue&type=script&lang=js"
import style0 from "./ct-project.vue?vue&type=style&index=0&id=2293bb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293bb52",
  null
  
)

export default component.exports